import { backendHost } from '../endpoint';

export function baseAuthPythonURL() {
  const url = new URL(backendHost);
  url.pathname += 'users/';
  return url;
}

export function getLogoutURL() {
  const url = baseAuthPythonURL();
  url.pathname += 'api/logout/';
  return url;
}
